export const lizenzvergabeWildcardsBundesliga202627 = {
  "id": "lizenzvergabe-wildcards-bundesliga-2026-27",
  "title": "Alle Lizenzen und Wildcards vergeben: Bundesligen starten in voller Stärke",
  "slug": "lizenzvergabe-wildcards-bundesliga-2026-27",
  "publishedAt": "2026-08-04T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "5 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Lizenzen",
    "Wildcard",
    "RBA",
    "Saison 2026/27"
  ],
  "excerpt": "Das Lizenzierungsverfahren für die Saison 2026/2027 ist abgeschlossen. Das Präsidium von Rugby Deutschland ist den Voten des Rugby Bundesligaausschusses gefolgt und hat allen 26 Vereinen der ersten und zweiten Bundesliga eine Lizenz erteilt.",
  "img": "/images/lizenzvergabe-2026-27-bundesliga.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Das Lizenzierungsverfahren für die Saison 2026/2027 ist abgeschlossen. Das Präsidium von Rugby Deutschland ist den Voten des Rugby Bundesligaausschusses gefolgt und hat allen 26 Vereinen der ersten und zweiten Bundesliga eine Lizenz erteilt."
    },
    {
      "type": "paragraph",
      "content": "Damit erhalten alle zehn Vereine der ersten Bundesliga sowie jeweils acht Vereine der zweiten Bundesliga Nord Ost und Süd West die Spielberechtigung für die kommende Saison. Kein Verein wurde vom Bundesligaspielbetrieb ausgeschlossen."
    },
    {
      "type": "paragraph",
      "content": "22 Vereine erhalten ihre Lizenz ohne Auflage. Bei vier Vereinen ist die Erteilung mit einer Auflage verbunden. Dies betrifft den SC Neuenheim, den Hamburger RC, StuSta Freimann und Walferdange Rugby."
    },
    {
      "type": "paragraph",
      "content": "Beim SC Neuenheim ist die Gleichwertigkeit der angegebenen Trainerlizenz bis zum 1. Mai 2027 nachzuweisen. Der Hamburger RC, StuSta Freimann und Walferdange Rugby müssen zum kommenden Lizenzantrag eine gültige Trainerlizenz vorlegen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Bundesligen erstmals vollständig besetzt"
    },
    {
      "type": "paragraph",
      "content": "In der Saison 2025/2026 hatten insgesamt 25 Vereine eine Bundesligalizenz erhalten. Während die erste Bundesliga und die zweite Bundesliga Süd West vollständig besetzt waren, trat die zweite Bundesliga Nord Ost lediglich mit sieben Mannschaften an."
    },
    {
      "type": "paragraph",
      "content": "Die Entwicklung lässt sich entsprechend klar darstellen:"
    },
    {
      "type": "list",
      "items": [
        "Saison 2025/2026: zehn Mannschaften in der ersten Bundesliga, sieben Mannschaften in der zweiten Bundesliga Nord Ost und acht Mannschaften in der zweiten Bundesliga Süd West – insgesamt 25 lizenzierte Vereine.",
        "Saison 2026/2027: zehn Mannschaften in der ersten Bundesliga sowie jeweils acht Mannschaften in den beiden Staffeln der zweiten Bundesliga – insgesamt 26 lizenzierte Vereine."
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Damit starten die erste Bundesliga und beide Staffeln der zweiten Bundesliga in der kommenden Saison in voller Stärke."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Steigende Anforderungen im Lizenzierungsverfahren"
    },
    {
      "type": "paragraph",
      "content": "Die aktuelle Vergabe zeigt zwei wesentliche Entwicklungen. Einerseits bleibt die Teilnahme aller sportlich qualifizierten Vereine gesichert. Andererseits werden bestehende Lücken häufiger durch konkrete Auflagen und festgesetzte Zahlungen begleitet."
    },
    {
      "type": "paragraph",
      "content": "Die aktuelle Übersicht weist Zahlungen in Höhe von insgesamt 25.150 Euro aus. Diese Summe setzt sich aus 19.150 Euro in der ersten Bundesliga, 2.000 Euro in der zweiten Bundesliga Nord Ost und 4.000 Euro in der zweiten Bundesliga Süd West zusammen. Die vollständige anonymisierte Übersicht der Lizenzvergabe ist hier einsehbar:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Anonymisierte Tabelle zur Lizenzvergabe 2026/27 (PDF)", "url": "/documents/lizenzvergabe-2026-27-uebersicht.pdf" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Ein wesentlicher Faktor ist die Erhöhung der Mindestanforderung von vier auf fünf aktive Schiedsrichter je Bundesligamannschaft für den Lizenzantrag 2026. Diese Entwicklung war bereits in der geltenden Lizenzordnung von Rugby Deutschland vorgesehen."
    },
    {
      "type": "paragraph",
      "content": "Weiterer Entwicklungsbedarf zeigt sich zudem bei den Trainerlizenzen. Die ausgesprochenen Auflagen sollen den betroffenen Vereinen die Möglichkeit geben, die noch erforderlichen Nachweise zu erbringen und ihre personellen Strukturen nachhaltig weiterzuentwickeln."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Positive Entwicklung im Jugendspielbetrieb"
    },
    {
      "type": "paragraph",
      "content": "Erfreulich ist die erkennbare Entwicklung im Jugendspielbetrieb. Mehrere Lücken, die in der vorherigen Lizenzrunde noch bestanden, konnten inzwischen geschlossen werden. Insbesondere die jüngeren Altersklassen sind deutlich besser besetzt und bilden damit eine wichtige Grundlage für die weitere Entwicklung der Vereine und des deutschen Rugbys."
    },
    {
      "type": "paragraph",
      "content": "Weiterhin groß sind jedoch die Lücken in den Altersklassen U16 und U18 sowie bei den Mädchenmannschaften der U15 und U18. Die inzwischen bessere Besetzung der jüngeren Altersklassen lässt erwarten, dass diese Mannschaften in den kommenden Jahren schrittweise aufgefüllt werden können."
    },
    {
      "type": "paragraph",
      "content": "Ein Wermutstropfen bleibt, dass ein Teil der Jugendmannschaften derzeit nur durch Spielgemeinschaften abgedeckt werden kann. Diese Kooperationen sind ein wichtiges Instrument, um jungen Spielerinnen und Spielern überhaupt einen regelmäßigen Spielbetrieb zu ermöglichen. Dauerhaft muss das gemeinsame Ziel jedoch darin bestehen, zunächst alle Lücken im Jugendspielbetrieb zu schließen und im nächsten Schritt möglichst viele eigenständige Jugendmannschaften in den Vereinen zu entwickeln."
    },
    {
      "type": "paragraph",
      "content": "Die Fortschritte zeigen, dass die Lizenzkriterien ihre gewünschte Entwicklungswirkung entfalten können. Gleichzeitig bleibt die nachhaltige Nachwuchsarbeit eine der zentralen Aufgaben für die kommenden Jahre."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Wildcards für beide Staffeln vergeben"
    },
    {
      "type": "paragraph",
      "content": "Im Anschluss an das reguläre Lizenzierungsverfahren hatte Rugby Deutschland jeweils einen freien Startplatz für die zweite Bundesliga Nord Ost und die zweite Bundesliga Süd West ausgeschrieben. Das Wildcardverfahren lief vom 1. bis zum 10. Juli 2026."
    },
    {
      "type": "paragraph",
      "content": "Für jede Staffel wurde eine eigene Bewertung vorgenommen. Voraussetzung für eine Vergabe waren mindestens zwölf Lizenzpunkte. Aktive Jugendmannschaften wurden mit jeweils zwei Punkten bewertet. Aktive Schiedsrichter mit C Lizenz erhielten einen Punkt, Schiedsrichter mit D Lizenz einen halben Punkt. Bei vergüteten Vereinstrainern wurden für eine A Lizenz 1,5 Punkte, für eine B Lizenz ein Punkt und für eine C Lizenz ein halber Punkt vergeben."
    },
    {
      "type": "paragraph",
      "content": "Für die Staffel Nord Ost bewarb sich ausschließlich der VfR Döhren 06. Für die Staffel Süd West ging ausschließlich die Bewerbung des Stuttgarter Rugbyclubs ein. Da für jede Staffel eine eigene Rangliste vorgesehen war, standen die beiden Vereine nicht in direkter Konkurrenz zueinander."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "VfR Döhren 06 erreicht 16,5 Punkte"
    },
    {
      "type": "paragraph",
      "content": "Der VfR Döhren 06 erhielt für sechs aktive Jugendmannschaften jeweils zwei Punkte. Daraus ergaben sich zwölf Jugendpunkte."
    },
    {
      "type": "paragraph",
      "content": "Hinzu kamen drei Punkte für die anerkannten Schiedsrichterlizenzen und 1,5 Punkte für die eingesetzten Vereinstrainer. Die Berechnung lautet:"
    },
    {
      "type": "paragraph",
      "emphasis": "strong",
      "content": "12 Jugendpunkte zuzüglich 3 Schiedsrichterpunkte zuzüglich 1,5 Trainerpunkte ergeben 16,5 Lizenzpunkte."
    },
    {
      "type": "paragraph",
      "content": "Der VfR Döhren 06 überschritt die erforderliche Mindestpunktzahl damit um 4,5 Punkte und erhält die Wildcard für die zweite Bundesliga Nord Ost."
    },
    {
      "type": "paragraph",
      "content": "Zusätzlich wurde eine Zahlung von 750 Euro festgesetzt, da fünf gemeldete Schiedsrichter nicht die erforderliche Zahl an Einsätzen erreicht hatten."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Stuttgarter Rugbyclub erreicht 17 Punkte"
    },
    {
      "type": "paragraph",
      "content": "Der Stuttgarter Rugbyclub erhielt für fünf aktive Jugendmannschaften jeweils zwei Punkte. Daraus ergaben sich zehn Jugendpunkte."
    },
    {
      "type": "paragraph",
      "content": "Die geprüfte Bewertung weist außerdem drei Schiedsrichterpunkte und vier Trainerpunkte aus. Die Berechnung lautet:"
    },
    {
      "type": "paragraph",
      "emphasis": "strong",
      "content": "10 Jugendpunkte zuzüglich 3 Schiedsrichterpunkte zuzüglich 4 Trainerpunkte ergeben 17 Lizenzpunkte."
    },
    {
      "type": "paragraph",
      "content": "Der Stuttgarter Rugbyclub überschritt die erforderliche Mindestpunktzahl damit um fünf Punkte und erhält die Wildcard für die zweite Bundesliga Süd West."
    },
    {
      "type": "paragraph",
      "content": "Wegen drei fehlender Schiedsrichter wurde eine zusätzliche Zahlung von 450 Euro festgesetzt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Vollständige Ligastruktur für die Saison 2026/2027"
    },
    {
      "type": "paragraph",
      "content": "Das Präsidium folgte bei beiden Wildcardanträgen dem Votum des Rugby Bundesligaausschusses. Die Lizenzen werden vorbehaltlich der Zahlung der jeweiligen Lizenzgebühr sowie der zusätzlich festgesetzten Beträge erteilt."
    },
    {
      "type": "paragraph",
      "content": "Mit dem VfR Döhren 06 in der Staffel Nord Ost und dem Stuttgarter Rugbyclub in der Staffel Süd West sind beide vakanten Startplätze besetzt."
    },
    {
      "type": "paragraph",
      "content": "Die erste Bundesliga startet damit mit zehn Mannschaften. Die zweite Bundesliga Nord Ost und die zweite Bundesliga Süd West gehen jeweils mit acht Mannschaften an den Start. Erstmals sind damit alle vorgesehenen Startplätze in den drei Bundesligastaffeln vollständig besetzt."
    }
  ]
};
